import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { hideGlobalConfirm } from '../actions';
import ConfirmModal from '../../../components/base/Dialog/ConfirmModal';
import { getGlobalConfirmData } from '../reducer';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

export default function GlobalConfirmModal() {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const {
    showConfirm = false,
    confirmTitle = '',
    confirmMessage = '',
    confirmClassName = '',
    confirmButtonText = '',
    confirmCancelButtonText = '',
    hideSubmit = false,
    promiseId = null,
  } = useSelector(getGlobalConfirmData);

  const onHideConfirm = () => {
    rejectActionPromise({ promiseId })();
    dispatch(hideGlobalConfirm());
  };

  const handleOk = () => {
    resolveActionPromise({ promiseId })();
    dispatch(hideGlobalConfirm());
  };
  return (
    <ConfirmModal
      show={showConfirm}
      onHide={onHideConfirm}
      onSubmit={handleOk}
      title={confirmTitle}
      confirmMessage={confirmMessage}
      buttonText={confirmButtonText || formatMessage({ id: 'app.continue' })}
      cancelButtonText={confirmCancelButtonText || formatMessage({ id: 'app.cancel' })}
      className={confirmClassName}
      hideSubmit={hideSubmit}
    />
  );
}
